import { App } from "../shared/components/newsroom-ch/app/index";
import "./newsroom-ch.module.scss";

const { createApp } = Vue;

(function (window) {
    
    function _init({config = {}, container = ''}) {
        const app = document.getElementById(container);

        if (app) {
            console.log("Lmu Newsroom Edit Content Hub Initilized");
            const app = createApp(App);            
            app.config.globalProperties.rootData = config,
            app.mount('#'+container);
            
        } else {
            console.log('LmuNewsroom Edit Content Hub Initilized Fail!');
        }

    }

    window.LmuNewsroomCH = {
        init : _init
    }


  })(window);